import CryptoJS from "crypto-js";
// REACT_APP_API_URL
// const cmsUrl = process.env.REACT_APP_CMS_URL;
const cmsUrl = process.env.REACT_APP_API_URL;

const sliderV1 = 'https://cms.spqrlab.com/api/';


class LocalManager {

    static async getSlider(sliderType) {
        try {
            const response = await fetch(`${cmsUrl}get_slider_by_type/${sliderType}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            return data; // Повертаємо отримані дані
        } catch (error) {
            console.error("Error fetching slider data:", error);
            throw error; // Генеруємо помилку, якщо щось пішло не так
        }
    }

    static async getLanguages() {
        try {
            const encryptedPayload = ({
                action: "GET_LANG_LIST",
            });
            const encryptedEndpoint = ("/ajax/test.php");

            // const response = await fetch(`${cmsUrl}get_lang_list`, {
            // const response = await fetch(`https://7vegas.xyztown.info/proxy/`, {
            const response = await fetch(`${cmsUrl}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    data: encryptedPayload,
                    endpoint: encryptedEndpoint,
                    nocrypt: true
                }),
            });

            // return (responseData);

            const data = await response.json();
            return data.data; // Повертаємо отримані дані
        } catch (error) {
            console.error("Error fetching languages:", error);
            throw error; // Генеруємо помилку, якщо щось пішло не так
        }
    }

    static async getMenuButtons(menuName, menuType) {
        try {
            const response = await fetch(`${cmsUrl}get_menu_buttons`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    menu_name: menuName,
                    menu_type: menuType,
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            return data; // Повертаємо отримані дані
        } catch (error) {
            console.error('Error fetching menu buttons:', error);
            throw error; // Генеруємо помилку, якщо щось пішло не так
        }
    }

}

export default LocalManager;
